export { unstable_detectScrollType as detectScrollType, unstable_getNormalizedScrollLeft as getNormalizedScrollLeft } from '@mui/utils';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/utils/scrollLeft.js
// module id = 1982
// module chunks = 25